// ==============================================================================
// ==============================================================================
import * as React from 'react';

import { ICopyrightData } from './copyright.data';
import { ICopyrightProps } from './copyright.props.autogenerated';

// ==============================================================================
// CLASS DEFINITION
// ==============================================================================
/**
 * Copyright component
 * @extends {React.PureComponent<ICopyrightProps<ICopyrightData>>}
 */
class Copyright extends React.PureComponent<ICopyrightProps<ICopyrightData>> {

    // ==============================================================================
    // PUBLIC METHODS
    // ==============================================================================

    // -----------------------------------------------------------
    // -----------------------------------------------------------
    public render(): JSX.Element {
        const { cssName } = this.props.config;

        return (
            <div className={`copyright ${cssName}`}>
                {this._copyrightTextFormatted}
            </div>
        );
    }

    // -----------------------------------------------------------
    // -----------------------------------------------------------
    private get _copyrightTextFormatted(): JSX.Element {
        const {
            copyrightText,
        } = this.props.config;

        const dateToUse = new Date().getFullYear().toString();

        return (
            <React.Fragment>
                © {dateToUse} {copyrightText}
            </React.Fragment>
        );
    }
}

export default Copyright;
